import React from 'react';
import PropTypes from 'prop-types';

import ATT from './ATT';
import ATTHOME from './ATTHome';
import COMCAST from './Comcast';
import RCT from './RingCentral';
import FORTEL from './Fortel';
import OOMA from './Ooma';

const Components = {
  ATT,
  COMCAST,
  ATTHOME,
  RCT,
  FORTEL,
  OOMA,
};

export default function CarrierInstructions(props) {
  const InstructionsComponent = Components[props.carrier];

  return (<InstructionsComponent {...props} />);
}

CarrierInstructions.defaultProps = {
  carrier: 'ATT',
};

CarrierInstructions.propTypes = {
  carrier: PropTypes.string,
};
